import React, { useState } from "react";
import PropTypes from "prop-types";
import { Menu, MenuItem, Button } from "@mui/material";

const CustomMenu = ({ icon, menuItems }) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <div>
      <Button
        id="basic-button"
        aria-controls={open ? "basic-menu" : undefined}
        aria-haspopup="true"
        aria-expanded={open ? "true" : undefined}
        onClick={handleClick}
        sx={{ width: "24px", height: "24px", minWidth: "24px" }}
      >
        <img src={icon} alt="hamburgerMenuIcon" />
      </Button>
      <Menu
        id="basic-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        MenuListProps={{ "aria-labelledby": "basic-button" }}
      >
        {menuItems.map((el) => (
          <MenuItem
            onClick={() => {
              el.func();
              handleClose();
            }}
            key={el.name}
            sx={{ fontSize: "14px" }}
          >
            {el.name}
          </MenuItem>
        ))}
      </Menu>
    </div>
  );
};

CustomMenu.propTypes = {
  icon: PropTypes.string.isRequired,
  menuItems: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string.isRequired,
      func: PropTypes.func.isRequired,
    })
  ).isRequired,
};

export default React.memo(CustomMenu);
